import { EventType } from "@/types";

import { axios } from "../axios.instance";

export type EditAffairRequest = Required<
  Pick<EventType, "title" | "description" | "photos" | "location" | "startDate" | "endDate" | "capacity">
> & {
  eventId: EventType["id"];
};

export type EditAffairResponse = EventType;

export const editAffair = async ({ eventId, ...body }: EditAffairRequest): Promise<EditAffairResponse> => {
  const { data } = await axios.patch(`/events/affairs/${eventId}/edit`, body);

  return data;
};
